// import React, { useEffect, useRef, useState } from 'react';
// import {
//   Box,
//   CircularProgress,
//   Typography,
//   Paper,
//   Avatar,
//   Chip,
//   Menu,
//   MenuItem,
// } from '@mui/material';
// import { SmartToy, Person, AccessTime } from '@mui/icons-material';
// import { LeadFormActions } from '../../Services/_actions/LeadForm/leadForm.actions';
// import { useParams } from 'react-router';
// import MathRenderer from '../Test/MathRenderer.tsx';

// interface Props {
//   leadId?: string; // Make it optional
// }

// const AiChatDetail: React.FC<Props> = ({ leadId: propLeadId }) => {
//   const { leadId: paramLeadId } = useParams<{ leadId: string }>();
  
//   // Use prop first, fallback to URL param
//   const leadId = propLeadId || paramLeadId;
  
//   console.log('AiChatDetail - propLeadId:', propLeadId);
//   console.log('AiChatDetail - paramLeadId:', paramLeadId);
//   console.log('AiChatDetail - final leadId:', leadId);
  
//   const { getAiChatDetail } = LeadFormActions();
//   const [loading, setLoading] = useState(true);
//   const [messages, setMessages] = useState<any[]>([]);
//   const chatRef = useRef<HTMLDivElement | null>(null);
//   const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);
//   const [selectedUrl, setSelectedUrl] = useState<string>('');

//   const handleLinkClick = (url: string, event: any) => {
//     setSelectedUrl(url);
//     setMenuAnchor(event.currentTarget);
//   };

//   const handleCloseMenu = () => {
//     setMenuAnchor(null);
//   };

//   const renderWithLinks = (text: string) => {
//     if (!text) return text;

//     const urlRegex = /(https?:\/\/[^\s]+)/g;
//     const parts = text.split(urlRegex);

//     return parts.map((part, index) => {
//       const isURL = part.startsWith('http://') || part.startsWith('https://');

//       if (isURL) {
//         return (
//           <span
//             key={index}
//             onClick={(e) => handleLinkClick(part, e)}
//             style={{
//               color: '#1976d2',
//               textDecoration: 'underline',
//               fontWeight: 500,
//               cursor: 'pointer',
//             }}
//           >
//             {part}
//           </span>
//         );
//       }

//       return <span key={index}>{part}</span>;
//     });
//   };

//   const fetchChat = async () => {
//     if (!leadId) {
//       console.error('No leadId available');
//       setLoading(false);
//       return;
//     }
    
//     try {
//       setLoading(true);
//       console.log('Fetching AI chat for leadId:', leadId);
//       const res = await getAiChatDetail(leadId);
      
//       console.log('API Response:', res);
      
//       if (res?.status === 200 || res?.status === true || res?.data?.status === true) {
//         let chatData = [];
        
//         if (res?.data?.data && Array.isArray(res.data.data)) {
//           chatData = res.data.data;
//         } else if (res?.data && Array.isArray(res.data)) {
//           chatData = res.data;
//         } else if (res?.data?.aichat && Array.isArray(res.data.aichat)) {
//           chatData = res.data.aichat;
//         }
        
//         console.log('Chat Data:', chatData);
        
//         const transformedMessages = chatData.map((item: any) => {
//           let outputText = '';
          
//           if (item.response?.response?.response) {
//             outputText = item.response.response.response;
//           } else if (item.output) {
//             outputText = item.output;
//           }
          
//           return {
//             input: item.query || item.input || '',
//             output: outputText,
//             datetime: item.timestamp || item.datetime || ''
//           };
//         });
        
//         console.log('Transformed Messages:', transformedMessages);
        
//         setMessages(transformedMessages);
//       } else {
//         console.log('No valid data found in response');
//         setMessages([]);
//       }
//     } catch (err) {
//       console.error('Failed to load AI chat', err);
//       setMessages([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (leadId) {
//       fetchChat();
//     }
//   }, [leadId]);

//   useEffect(() => {
//     if (chatRef.current) {
//       chatRef.current.scrollTop = chatRef.current.scrollHeight;
//     }
//   }, [messages]);

//   const formatTimestamp = (datetime: string) => {
//     if (!datetime) return '';
//     const date = new Date(datetime);
//     const now = new Date();
//     const diffMs = now.getTime() - date.getTime();
//     const diffMins = Math.floor(diffMs / 60000);
//     const diffHours = Math.floor(diffMs / 3600000);
//     const diffDays = Math.floor(diffMs / 86400000);

//     if (diffMins < 1) return 'Just now';
//     if (diffMins < 60) return `${diffMins}m ago`;
//     if (diffHours < 24) return `${diffHours}h ago`;
//     if (diffDays < 7) return `${diffDays}d ago`;

//     return date.toLocaleDateString('en-US', {
//       month: 'short',
//       day: 'numeric',
//       hour: '2-digit',
//       minute: '2-digit',
//     });
//   };

//   if (loading) {
//     return (
//       <Box
//         sx={{
//           display: 'flex',
//           flexDirection: 'column',
//           alignItems: 'center',
//           justifyContent: 'center',
//           minHeight: { xs: '50vh', md: '70vh' },
//           p: 3,
//         }}
//       >
//         <CircularProgress size={50} thickness={4} sx={{ color: '#5e72e4' }} />
//         <Typography mt={3} color="text.secondary" fontSize={15}>
//           Loading chat conversation...
//         </Typography>
//       </Box>
//     );
//   }

//   if (!messages.length) {
//     return (
//       <Box
//         sx={{
//           display: 'flex',
//           flexDirection: 'column',
//           alignItems: 'center',
//           justifyContent: 'center',
//           minHeight: { xs: '50vh', md: '70vh' },
//           p: 3,
//           textAlign: 'center',
//         }}
//       >
//         <SmartToy sx={{ fontSize: 64, color: '#ddd', mb: 2 }} />
//         <Typography variant="h6" fontWeight={600} color="text.primary" mb={1}>
//           No Chat History Available
//         </Typography>
//         <Typography color="text.secondary" fontSize={14}>
//           This conversation hasn't started yet or no messages were found.
//         </Typography>
//       </Box>
//     );
//   }

//   return (
//     <Box sx={{ maxWidth: 1200, mx: 'auto' }}>
//       <Paper
//         elevation={0}
//         sx={{
//           borderRadius: 3,
//           border: '1px solid #f0f0f0',
//           boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
//           height: { xs: 'calc(100vh - 100px)', md: '75vh' },
//           display: 'flex',
//           flexDirection: 'column',
//           overflow: 'hidden',
//         }}
//       >
//         {/* Header */}
//         <Box
//           sx={{
//             p: { xs: 2, sm: 3 },
//             borderBottom: '1px solid #f0f0f0',
//             backgroundColor: '#fff',
//           }}
//         >
//           <Box
//             sx={{
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'space-between',
//               flexWrap: 'wrap',
//               gap: 2,
//             }}
//           >
//             <Box>
//               <Typography
//                 variant="h5"
//                 fontWeight={700}
//                 color="#2c3e50"
//                 sx={{ fontSize: { xs: '1.25rem', sm: '1.5rem' } }}
//               >
//                 AI Chat Conversation
//               </Typography>
//             </Box>

//             <Chip
//               icon={<AccessTime sx={{ fontSize: 18 }} />}
//               label={`${messages.length} message${messages.length > 1 ? 's' : ''}`}
//               sx={{
//                 bgcolor: '#f0fff5ff',
//                 color: '#1976d2',
//                 fontWeight: 600,
//                 fontSize: { xs: 11, sm: 12 },
//                 height: { xs: 28, sm: 32 },
//               }}
//             />
//           </Box>
//         </Box>

//         {/* Chat Messages Area */}
//         <Box
//           ref={chatRef}
//           sx={{
//             flexGrow: 1,
//             overflowY: 'auto',
//             p: { xs: 2, sm: 3 },
//            background: 'linear-gradient(to bottom, #efeae2 0%, #f7f7f7 100%)',
//             WebkitOverflowScrolling: 'touch',
//           }}
//         >
//           {messages.map((msg, i) => (
//             <Box key={i} sx={{ mb: 3 }}>
//               {/* User Message */}
//               <Box
//                 sx={{
//                   display: 'flex',
//                   justifyContent: 'flex-start',
//                   mb: 1.5,
//                 }}
//               >
//                 <Box
//                   sx={{
//                     display: 'flex',
//                     gap: { xs: 1, sm: 1.5 },
//                     maxWidth: { xs: '90%', sm: '75%' },
//                     alignItems: 'flex-start',
//                   }}
//                 >
//                   <Avatar
//                     sx={{
//                       width: { xs: 32, sm: 36 },
//                       height: { xs: 32, sm: 36 },
//                       bgcolor: '#5e72e4',
//                       fontSize: { xs: 16, sm: 18 },
//                     }}
//                   >
//                     <Person sx={{ fontSize: { xs: 18, sm: 20 } }} />
//                   </Avatar>

//                   <Box sx={{ flex: 1 }}>
//                     <Box
//                       sx={{
//                         p: { xs: 1.5, sm: 2 },
//                         borderRadius: '12px 12px 12px 4px',
//                         bgcolor: '#ffffff',
//                         border: '1px solid #e8eaf0',
//                         boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
//                         position: 'relative',
//                       }}
//                     >
//                       <Typography
//                         sx={{
//                           fontSize: { xs: '0.875rem', sm: '0.95rem' },
//                           lineHeight: 1.6,
//                           color: '#2c3e50',
//                           wordBreak: 'break-word',
//                           whiteSpace: 'pre-wrap',
//                         }}
//                       >
//                         {msg?.input}
//                       </Typography>
//                     </Box>

//                     <Typography
//                       variant="caption"
//                       sx={{
//                         display: 'flex',
//                         alignItems: 'center',
//                         gap: 0.5,
//                         mt: 0.5,
//                         ml: 1,
//                         fontSize: { xs: 10, sm: 11 },
//                         color: '#999',
//                       }}
//                     >
//                       <AccessTime sx={{ fontSize: 12 }} />
//                       {formatTimestamp(msg?.datetime)}
//                     </Typography>
//                   </Box>
//                 </Box>
//               </Box>
 
//               {/* Bot Message */}
// <Box sx={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
//   <Box
//     sx={{
//       display: 'flex',
//       gap: { xs: 0.75, sm: 1.5 },          // 🔥 REDUCE GAP ON MOBILE
//       width: '100%',                       // 🔥 allow stretch
//       maxWidth: { xs: '96%', sm: '75%' },  // 🔥 tighter on mobile
//       alignItems: 'stretch',               // 🔥 IMPORTANT
//       flexDirection: 'row-reverse',
//     }}
//   >
//     <Avatar
//       sx={{
//         width: { xs: 28, sm: 36 },          // 🔥 smaller avatar mobile
//         height: { xs: 28, sm: 36 },
//         bgcolor: '#2dce89',
//         flexShrink: 0,
//       }}
//     >
//       <SmartToy fontSize="small" />
//     </Avatar>

//     <Box
//       sx={{
//         flex: 1,
//         minWidth: 0,                        // 🔥 CRITICAL for mobile
//       }}
//     >
//       <Box
//         sx={{
//           p: { xs: 1.25, sm: 2 },           // 🔥 reduce padding mobile
//           borderRadius: '12px 12px 4px 12px',
//           bgcolor: '#e6f7ed',
//           border: '1px solid #c8e6d0',

//           width: '100%',
//           maxWidth: '100%',
//           overflow: 'visible',
//           wordBreak: 'break-word',
//           overflowWrap: 'anywhere',
//         }}
//       >
//         <Box
//           sx={{
//             width: '100%',
//             maxWidth: '100%',
//             overflowX: 'auto',              // equations scroll if needed
//           }}
//         >
//           <MathRenderer content={msg?.output || 'No response'} />
//         </Box>
//       </Box>

//       <Typography
//         variant="caption"
//         sx={{
//           display: 'flex',
//           justifyContent: 'flex-end',
//           alignItems: 'center',
//           gap: 0.4,
//           mt: 0.25,                         // 🔥 reduce vertical gap
//           mr: 0.5,
//           fontSize: { xs: 9, sm: 11 },      // 🔥 smaller timestamp mobile
//           color: '#999',
//         }}
//       >
//         <AccessTime sx={{ fontSize: 11 }} />
//         {formatTimestamp(msg?.datetime)}
//       </Typography>
//     </Box>
//   </Box>
// </Box>


//             </Box>
//           ))}
//         </Box>

//         {/* Footer Info */}
//         <Box
//           sx={{
//             p: { xs: 1.5, sm: 2 },
//             borderTop: '1px solid #f0f0f0',
//             backgroundColor: '#fafbfc',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             gap: 1,
//           }}
//         >
//           <SmartToy sx={{ fontSize: 16, color: '#2dce89' }} />
//           <Typography
//             variant="caption"
//             color="text.secondary"
//             sx={{ fontSize: { xs: 11, sm: 12 } }}
//           >
//             AI-powered conversation history
//           </Typography>
//         </Box>

//         <Menu anchorEl={menuAnchor} open={Boolean(menuAnchor)} onClose={handleCloseMenu}>
//           <MenuItem
//             onClick={() => {
//               window.open(selectedUrl, '_blank');
//               handleCloseMenu();
//             }}
//           >
//             Open Link
//           </MenuItem>

//           <MenuItem>
//             Add to Knowledge Map
//           </MenuItem>

//           <MenuItem onClick={handleCloseMenu}>Cancel</MenuItem>
//         </Menu>
//       </Paper>
//     </Box>
//   );
// };

// export default AiChatDetail;



import React, { useEffect, useRef, useState } from 'react';
import {
  Box,
  CircularProgress,
  Typography,
  Paper,
  Avatar,
  Chip,
  Menu,
  MenuItem,
  TextField,
  Button,
  IconButton,
  InputAdornment,
} from '@mui/material';
import { SmartToy, Person, AccessTime, Send, RestartAlt, Mic } from '@mui/icons-material';
import { LeadFormActions } from '../../Services/_actions/LeadForm/leadForm.actions';
import { AiActions } from '../../Services/_actions';
import { useParams } from 'react-router';
import MathRenderer from '../Test/MathRenderer.tsx';
import { useRecoilValue } from 'recoil';
import { userInformationAtom } from '../../Services/_states/auth.js';

interface Props {
  leadId?: string;
}

interface Message {
  input?: string;
  output?: string;
  datetime?: string;
  type?: 'user' | 'ai';
  content?: string;
  diagram_html?: string;
  test_url?: string;
}

const extractAIText = (aiResp: any): string => {
  if (!aiResp) return 'No answer found';

  if (typeof aiResp === 'string') {
    return aiResp.trim() || 'No answer found';
  }

  const text =
    aiResp?.data?.response?.response ??
    aiResp?.response?.response?.response ??
    aiResp?.response?.response ??
    aiResp?.response ??
    aiResp?.output_query ??
    '';

  if (typeof text === 'string' && text.trim().length > 0) {
    return text;
  }

  return 'No answer found';
};

const AiChatDetail: React.FC<Props> = ({ leadId: propLeadId }) => {
  const { leadId: paramLeadId } = useParams<{ leadId: string }>();
  const leadId = propLeadId || paramLeadId;
  
  const { getAiChatDetail } = LeadFormActions();
  const actions = AiActions();
  const loggedInUser = useRecoilValue(userInformationAtom);
  const mobile = loggedInUser?.mobile;
  const userId = loggedInUser?.id || loggedInUser?.user_id || '';
  
  const [loading, setLoading] = useState(true);
  const [messages, setMessages] = useState<Message[]>([]);
  const [userInput, setUserInput] = useState('');
  const [conversationId, setConversationId] = useState<string | null>(null);
  const [isWaitingForResponse, setIsWaitingForResponse] = useState(false);
  const [conversationMetadata, setConversationMetadata] = useState<any>(null);
  
  // Voice recognition states
  const recognitionRef = useRef<SpeechRecognition | null>(null);
  const [isListening, setIsListening] = useState(false);
  
  const chatRef = useRef<HTMLDivElement | null>(null);
  const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);
  const [selectedUrl, setSelectedUrl] = useState<string>('');

  const handleLinkClick = (url: string, event: any) => {
    setSelectedUrl(url);
    setMenuAnchor(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setMenuAnchor(null);
  };

  const fetchChat = async () => {
    if (!leadId) {
      console.error('No leadId available');
      setLoading(false);
      return;
    }
    
    try {
      setLoading(true);
      console.log('Fetching AI chat for leadId:', leadId);
      const res = await getAiChatDetail(leadId);
      
      console.log('API Response:', res);
      
      if (res?.status === 200 || res?.status === true || res?.data?.status === true) {
        let chatData = [];
        
        if (res?.data?.data && Array.isArray(res.data.data)) {
          chatData = res.data.data;
        } else if (res?.data && Array.isArray(res.data)) {
          chatData = res.data;
        } else if (res?.data?.aichat && Array.isArray(res.data.aichat)) {
          chatData = res.data.aichat;
        }
        
        // Extract conversation metadata
        if (chatData.length > 0) {
          const firstMessage = chatData[0];
          setConversationMetadata({
            subject: firstMessage.subject,
            topic: firstMessage.topic,
            subtopic: firstMessage.subtopic,
            instructionSet: firstMessage.instruction_set,
          });
          setConversationId(leadId);
        }
        
        const transformedMessages = chatData.map((item: any) => {
          let outputText = '';
          
          // Handle different response structures
          if (typeof item.response === 'string') {
            // Direct string response (like the decimal expansion message)
            outputText = item.response;
          } else if (item.response?.response?.response) {
            // Deeply nested response
            outputText = item.response.response.response;
          } else if (item.response?.response) {
            // Single nested response
            outputText = item.response.response;
          } else if (item.output) {
            // Fallback to output field
            outputText = item.output;
          }
          
          return {
            input: item.query || item.input || '',
            output: outputText || 'No response available',
            datetime: item.created_at || item.timestamp || item.datetime || '',
            type: undefined,
          };
        });
        
        setMessages(transformedMessages);
      } else {
        setMessages([]);
      }
    } catch (err) {
      console.error('Failed to load AI chat', err);
      setMessages([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (leadId) {
      fetchChat();
    }
  }, [leadId]);

  useEffect(() => {
    if (chatRef.current) {
      chatRef.current.scrollTop = chatRef.current.scrollHeight;
    }
  }, [messages]);

  // Cleanup voice recognition on unmount
  useEffect(() => {
    return () => {
      if (recognitionRef.current) {
        recognitionRef.current.stop();
      }
    };
  }, []);

  const formatTimestamp = (datetime: string) => {
    if (!datetime) return '';
    const date = new Date(datetime);
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) return 'Just now';
    if (diffMins < 60) return `${diffMins}m ago`;
    if (diffHours < 24) return `${diffHours}h ago`;
    if (diffDays < 7) return `${diffDays}d ago`;

    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  const handleMicClick = () => {
    if (!('webkitSpeechRecognition' in window) && !('SpeechRecognition' in window)) {
      alert('Speech recognition not supported in this browser.');
      return;
    }

    if (isListening) {
      recognitionRef.current?.stop();
      setIsListening(false);
      return;
    }

    const SpeechRecognition = (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;
    const recognition = new SpeechRecognition();
    recognitionRef.current = recognition;
    recognition.continuous = true;
    recognition.interimResults = true;
    recognition.lang = 'en-US';

    recognition.onresult = (event: any) => {
      let interimTranscript = '';
      for (let i = event.resultIndex; i < event.results.length; i++) {
        const result = event.results[i];
        if (result.isFinal) {
          setUserInput((prev) => prev + result[0].transcript + ' ');
        } else {
          interimTranscript += result[0].transcript;
        }
      }
    };

    recognition.onend = () => {
      setIsListening(false);
    };

    recognition.onerror = (e: any) => {
      console.error('Speech recognition error:', e);
      setIsListening(false);
    };

    recognition.start();
    setIsListening(true);
  };

  const handleSendQuestion = async () => {
    if (!userInput.trim() || !conversationMetadata) return;

    // Stop listening if active
    if (isListening && recognitionRef.current) {
      recognitionRef.current.stop();
      setIsListening(false);
    }

    const question = userInput;
    const newUserMessage: Message = {
      input: question,
      output: '',
      datetime: new Date().toISOString(),
      type: 'user',
    };
    
    setMessages((prev) => [...prev, newUserMessage]);
    setUserInput('');
    setIsWaitingForResponse(true);

    // Add thinking message
    const thinkingMessage: Message = {
      input: '',
      output: 'Let me think about that... 🤔',
      datetime: new Date().toISOString(),
      type: 'ai',
    };
    setMessages((prev) => [...prev, thinkingMessage]);

    try {
      const payload = {
        query: question,
        instruction: conversationMetadata.instructionSet || '',
        subject: conversationMetadata.subject || '',
        topic: conversationMetadata.topic || '',
        subtopic: conversationMetadata.subtopic || '',
        flowType: 'doubt',
        campaign_id: 'SCHSCH7125',
        lead_form_id: '492',
        conversation_id: conversationId,
      };

      const response = await actions.getTestDoubtData(payload);

      let aiAnswerText = 'No answer found';
      const aiResp = response?.ai_response;

      if (typeof aiResp === 'string') {
        aiAnswerText = aiResp;
      } else if (aiResp && typeof aiResp === 'object') {
        aiAnswerText = extractAIText(aiResp);
      }

      // Remove thinking message and add actual response
      setMessages((prev) => {
        const withoutThinking = prev.slice(0, -1);
        return [
          ...withoutThinking,
          {
            input: '',
            output: aiAnswerText,
            datetime: new Date().toISOString(),
            type: 'ai',
          },
        ];
      });

      setIsWaitingForResponse(false);

    } catch (error) {
      setMessages((prev) => {
        const withoutThinking = prev.slice(0, -1);
        return [
          ...withoutThinking,
          {
            input: '',
            output: '❌ Sorry, something went wrong. Please try again.',
            datetime: new Date().toISOString(),
            type: 'ai',
          },
        ];
      });
      setIsWaitingForResponse(false);
      console.error(error);
    }
  };

  const handleReset = () => {
    if (window.confirm('Are you sure you want to reset this conversation?')) {
      fetchChat(); // Reload original messages
      setUserInput('');
    }
  };

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: { xs: '50vh', md: '70vh' },
          p: 3,
        }}
      >
        <CircularProgress size={50} thickness={4} sx={{ color: '#5e72e4' }} />
        <Typography mt={3} color="text.secondary" fontSize={15}>
          Loading chat conversation...
        </Typography>
      </Box>
    );
  }

  if (!messages.length && !conversationMetadata) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: { xs: '50vh', md: '70vh' },
          p: 3,
          textAlign: 'center',
        }}
      >
        <SmartToy sx={{ fontSize: 64, color: '#ddd', mb: 2 }} />
        <Typography variant="h6" fontWeight={600} color="text.primary" mb={1}>
          No Chat History Available
        </Typography>
        <Typography color="text.secondary" fontSize={14}>
          This conversation hasn't started yet or no messages were found.
        </Typography>
      </Box>
    );
  }

  return (
    <Box className="chatnewcont" sx={{ maxWidth: 1200, mx: 'auto' }}>
      <Paper
        elevation={0}
        sx={{
          borderRadius: 3,
          border: '1px solid #f0f0f0',
          boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
          height: { xs: 'calc(100vh - 100px)', md: '80vh' },
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        {/* Header */}
        <Box
          sx={{
            p: { xs: 1, sm: 1.5 },
            borderBottom: '1px solid #f0f0f0',
            backgroundColor: '#fff',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              flexWrap: 'wrap',
              gap: 1,
            }}
          >
            <Box>
              <Typography
                variant="h6"
                fontWeight={600}
                color="#2c3e50"
                sx={{ fontSize: { xs: '1rem', sm: '1.1rem' } }}
              >
                AI Chat Conversation
              </Typography>
              {conversationMetadata && (
                <Typography variant="caption" color="text.secondary" sx={{ fontSize: { xs: '10px', sm: '11px' }, display: 'block', lineHeight: 1.3 }}>
                  {conversationMetadata.subject} • {conversationMetadata.topic}
                  {conversationMetadata.subtopic && ` • ${conversationMetadata.subtopic}`}
                </Typography>
              )}
            </Box>

            <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
              <Chip
                icon={<AccessTime sx={{ fontSize: 14 }} />}
                label={`${messages.length} msg${messages.length > 1 ? 's' : ''}`}
                sx={{
                  bgcolor: '#f0fff5ff',
                  color: '#1976d2',
                  fontWeight: 600,
                  fontSize: { xs: 10, sm: 11 },
                  height: { xs: 24, sm: 26 },
                }}
              />
              <IconButton
                onClick={handleReset}
                size="small"
                sx={{
                  color: '#667eea',
                  '&:hover': { bgcolor: 'rgba(102, 126, 234, 0.1)' },
                  p: 0.5,
                }}
                title="Reset to original conversation"
              >
                <RestartAlt sx={{ fontSize: 18 }} />
              </IconButton>
            </Box>
          </Box>
        </Box>

        {/* Chat Messages Area */}
        <Box
          ref={chatRef}
          sx={{
            flexGrow: 1,
            overflowY: 'auto',
            p: { xs: 1.5, sm: 2 },
            background: 'linear-gradient(to bottom, #efeae2 0%, #f7f7f7 100%)',
            WebkitOverflowScrolling: 'touch',
          }}
        >
          {messages.map((msg, i) => (
            <Box key={i} sx={{ mb: 1.5 }}>
              {/* User Message */}
              {msg.input && (
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                    mb: 1,
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      gap: { xs: 0.75, sm: 1 },
                      maxWidth: { xs: '90%', sm: '75%' },
                      alignItems: 'flex-start',
                    }}
                  >
                    <Avatar
                      sx={{
                        width: { xs: 28, sm: 32 },
                        height: { xs: 28, sm: 32 },
                        bgcolor: '#5e72e4',
                        fontSize: { xs: 14, sm: 16 },
                      }}
                    >
                      <Person sx={{ fontSize: { xs: 16, sm: 18 } }} />
                    </Avatar>

                    <Box sx={{ flex: 1 }}>
                      <Box
                        sx={{
                          p: { xs: 1, sm: 1.5 },
                          borderRadius: '12px 12px 12px 4px',
                          bgcolor: '#ffffff',
                          border: '1px solid #e8eaf0',
                          boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
                          position: 'relative',
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: { xs: '0.875rem', sm: '0.95rem' },
                            lineHeight: 1.6,
                            color: '#2c3e50',
                            wordBreak: 'break-word',
                            whiteSpace: 'pre-wrap',
                          }}
                        >
                          {msg.input}
                        </Typography>
                      </Box>

                      <Typography
                        variant="caption"
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 0.5,
                          mt: 0.5,
                          ml: 1,
                          fontSize: { xs: 10, sm: 11 },
                          color: '#999',
                        }}
                      >
                        <AccessTime sx={{ fontSize: 12 }} />
                        {formatTimestamp(msg.datetime || '')}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              )}

              {/* Bot Message */}
              {msg.output && (
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
                  <Box
                    sx={{
                      display: 'flex',
                      gap: { xs: 0.75, sm: 1.5 },
                      width: '100%',
                      maxWidth: { xs: '96%', sm: '75%' },
                      alignItems: 'stretch',
                      flexDirection: 'row-reverse',
                    }}
                  >
                    <Avatar
                      sx={{
                        width: { xs: 26, sm: 30 },
                        height: { xs: 26, sm: 30 },
                        bgcolor: '#2dce89',
                        flexShrink: 0,
                      }}
                    >
                      <SmartToy sx={{ fontSize: { xs: 14, sm: 16 } }} />
                    </Avatar>

                    <Box
                      sx={{
                        flex: 1,
                        minWidth: 0,
                      }}
                    >
                      <Box
                        sx={{
                          p: { xs: 1, sm: 1.5 },
                          borderRadius: '12px 12px 4px 12px',
                          bgcolor: '#e6f7ed',
                          border: '1px solid #c8e6d0',
                          width: '100%',
                          maxWidth: '100%',
                          overflow: 'visible',
                          wordBreak: 'break-word',
                          overflowWrap: 'anywhere',
                        }}
                      >
                        <Box
                          sx={{
                            width: '100%',
                            maxWidth: '100%',
                            overflowX: 'auto',
                          }}
                        >
                          <MathRenderer content={msg.output} />
                        </Box>
                      </Box>

                      <Typography
                        variant="caption"
                        sx={{
                          display: 'flex',
                          justifyContent: 'flex-end',
                          alignItems: 'center',
                          gap: 0.4,
                          mt: 0.25,
                          mr: 0.5,
                          fontSize: { xs: 9, sm: 11 },
                          color: '#999',
                        }}
                      >
                        <AccessTime sx={{ fontSize: 11 }} />
                        {formatTimestamp(msg.datetime || '')}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              )}
            </Box>
          ))}
        </Box>

        {/* Input Area */}
        <Box
          sx={{
            p: { xs: 1, sm: 1.5 },
            borderTop: '1px solid #e5e7eb',
            bgcolor: '#fff',
            flexShrink: 0,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              gap: { xs: 1, md: 2 },
              alignItems: 'flex-end',
              flexDirection: { xs: 'column', sm: 'row' },
            }}
          >
            <TextField
              fullWidth
              multiline
              maxRows={4}
              value={userInput}
              onChange={(e) => setUserInput(e.target.value)}
              onKeyPress={(e) => {
                if (e.key === 'Enter' && !e.shiftKey) {
                  e.preventDefault();
                  handleSendQuestion();
                }
              }}
              placeholder={
                !conversationMetadata
                  ? 'No conversation context available...'
                  : isWaitingForResponse
                  ? 'Waiting for response...'
                  : 'Continue the conversation...'
              }
              disabled={!conversationMetadata || isWaitingForResponse}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <IconButton
                      size="small"
                      onClick={handleMicClick}
                      color={isListening ? 'primary' : 'default'}
                      disabled={!conversationMetadata || isWaitingForResponse}
                      sx={{
                        color: isListening ? '#667eea' : '#666',
                        '&:hover': {
                          bgcolor: 'rgba(102, 126, 234, 0.1)',
                        },
                      }}
                    >
                      <Mic fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 3,
                  fontSize: { xs: 13, md: 14 },
                },
              }}
            />

            <Button
              variant="contained"
              onClick={handleSendQuestion}
              disabled={!userInput.trim() || !conversationMetadata || isWaitingForResponse}
              endIcon={<Send />}
              fullWidth={false}
              sx={{
                bgcolor: '#667eea',
                textTransform: 'none',
                fontWeight: 600,
                px: 3,
                py: 1.5,
                borderRadius: 3,
                fontSize: { xs: 13, md: 14 },
                minWidth: { xs: '100%', sm: '120px' },
                '&:hover': { bgcolor: '#5568d3' },
                '&:disabled': { bgcolor: '#e5e7eb' },
              }}
            >
              Send
            </Button>
          </Box>
        </Box>

        <Menu anchorEl={menuAnchor} open={Boolean(menuAnchor)} onClose={handleCloseMenu}>
          <MenuItem
            onClick={() => {
              window.open(selectedUrl, '_blank');
              handleCloseMenu();
            }}
          >
            Open Link
          </MenuItem>
          <MenuItem>Add to Knowledge Map</MenuItem>
          <MenuItem onClick={handleCloseMenu}>Cancel</MenuItem>
        </Menu>
      </Paper>
    </Box>
  );
};

export default AiChatDetail;